import {API_URL, apiPost} from '../api'
import {ApiRes} from '../../types/api'
import {IAnnouncement} from './getAnnounceList'

export const postCreateAnnounce = async (data: IAnnouncement): Promise<ApiRes<IAnnouncement>> => {
    return await apiPost(API_URL, 'official/post', data)
}
